import { useAtom } from 'jotai';
import ToggleSwitch from 'components/ui/ToggleSwitch/ToggleSwitch';
import useRudderStackTrack from 'hooks/useRudderStackTrack';
import { FlexAlignCenter, FlexColAlignStart } from 'components/primitives/flex';
import InstantBookIcon from 'assets/images/icons/instant-booking.svg';
import styled from 'styled-components';
import { instantBookTempAtom } from '../filterStore';

export default function InstantBookFilterSwitch() {
  const [isInstant, toggleInstantBook] = useAtom(instantBookTempAtom);

  const rudderTrack = useRudderStackTrack();

  return (
    <ToggleSwitch
      isActive={isInstant}
      onChange={() => {
        toggleInstantBook();
        rudderTrack('instant_book_toggle_search', {
          value: true,
        });
      }}
      onLabel={null}
      offLabel={null}
      icon={null}
      round
      invertColor
    />
  );
}

export const InstantBookFilterLabel = () => (
  <FlexColAlignStart>
    <FlexAlignCenter gap="8px">
      Instant Book
      <InstantBookIcon width={18} height={18} />
    </FlexAlignCenter>
    <TextWrapper>Book a boat without waiting for approval.</TextWrapper>
  </FlexColAlignStart>
);

const TextWrapper = styled(FlexAlignCenter)`
  font-size: 10px;
  font-weight: 400;
  line-height: 16px;
`;
